/* eslint-disable */
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "antd";
import {
  CheckCircle2,
  XCircle,
  AlertCircle,
  Clock,
  Calendar,
  Copy,
  TrendingUp,
  Info,
} from "lucide-react";

const StatisticsCard = ({
  title,
  count,
  icon: Icon,
  color,
  trend,
  description,
  statusTypes,
}) => {
  const colorClasses = {
    green: "bg-green-50 dark:!bg-[#0f4c2f] text-green-600 dark:text-green-400 border-green-200 dark:!border-green-800",
    red: "bg-red-50 dark:!bg-[#4c0f0f] text-red-600 dark:text-red-400 border-red-200 dark:!border-red-800",
    yellow: "bg-yellow-50 dark:!bg-[#4c3d0f] text-yellow-600 dark:text-yellow-400 border-yellow-200 dark:!border-yellow-800",
    blue: "bg-blue-50 dark:!bg-[#0f2f4c] text-blue-600 dark:text-blue-400 border-blue-200 dark:!border-blue-800",
    purple: "bg-purple-50 dark:!bg-[#3d0f4c] text-purple-600 dark:text-purple-400 border-purple-200 dark:!border-purple-800",
    orange: "bg-orange-50 dark:!bg-[#4c2a0f] text-orange-600 dark:text-orange-400 border-orange-200 dark:!border-orange-800",
  };

  const iconBgClasses = {
    green: "bg-green-100 dark:!bg-green-900",
    red: "bg-red-100 dark:!bg-red-900",
    yellow: "bg-yellow-100 dark:!bg-yellow-900",
    blue: "bg-blue-100 dark:!bg-blue-900",
    purple: "bg-purple-100 dark:!bg-purple-900",
    orange: "bg-orange-100 dark:!bg-orange-900",
  };

  return (
    <div
      className={`rounded-xl p-6 border-2 ${colorClasses[color]} bg-white dark:!bg-[#181919] shadow-sm hover:shadow-md transition-shadow`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400">
              {title}
            </p>
            {statusTypes && (
              <Tooltip
                title={
                  <div className="text-xs text-gray-800 dark:text-gray-100">
                    {statusTypes}
                  </div>
                }
                slotProps={{
                  tooltip: {
                    sx: {
                      bgcolor: "#ffffff",
                      color: "#1f2937",
                      border: "1px solid #e5e7eb",
                      fontSize: "12px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      "&.MuiTooltip-tooltip": {
                        backgroundColor: "#ffffff",
                        color: "#1f2937",
                      },
                    },
                  },
                }}
              >
                <Info
                  size={16}
                  className="
                            text-gray-600
                            dark:text-gray-300
                            cursor-help
                            hover:text-purple-600
                            dark:hover:text-purple-400
                            transition-colors
                          "
                />
              </Tooltip>
            )}

          </div>
          <div className="flex items-baseline gap-2">
            <h3 className="text-3xl font-bold text-gray-900 dark:text-gray-100">
              {count}
            </h3>
            {trend && (
              <span className="flex items-center gap-1 text-xs font-medium text-green-600 dark:text-green-400">
                <TrendingUp size={14} />
                {trend}
              </span>
            )}
          </div>
          {description && (
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
              {description}
            </p>
          )}
        </div>
        <div className={`p-3 rounded-lg ${iconBgClasses[color]}`}>
          <Icon size={24} className={`text-${color}-600`} />
        </div>
      </div>
    </div>
  );
};

export default StatisticsCard;
